import React from 'react';
import LibraryScreen from '@/screens/library/LibraryScreen';

export default function MoreLibraryScreen() {
  return <LibraryScreen />;
}
